import React from 'react'
import clsx from 'clsx';
import { Element } from './'

export const RepeaterItem = props => {
    const { element: { inline } } = props;
    return (
        <div className={clsx("repeater-item", { ["repeater-item-inline"]: inline }) }>
            <Element {...props}></Element>
        </div>
    )
}

export default RepeaterItem;